export default __webpack_public_path__ + "static/24-6e20ed8969d7a8a9f1c0933fa6c8f4c7.webp";